import { render, staticRenderFns } from "./AppAbout.vue?vue&type=template&id=6230ac52&scoped=true"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"
import style0 from "./AppAbout.vue?vue&type=style&index=0&id=6230ac52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230ac52",
  null
  
)

export default component.exports